import { Model } from "@shared-features/models/model";
import { Expose } from "class-transformer";
import { TopTenFleet } from "./top-ten-fleet.model";

export class TopTenFleetsResponse extends Model {
    @Expose() list: TopTenFleet[];
    @Expose() lastRefreshTime: number;
}
